import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const InstagramIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Instagram</title>
      <path
        d="M14.1274 6C9.65144 6 6 9.65144 6 14.1274V25.8726C6 30.3486 9.65144 34 14.1274 34H25.8726C30.3486 34 34 30.3486 34 25.8726V14.1274C34 9.65144 30.3486 6 25.8726 6H14.1274ZM14.1274 8.15385H25.8726C29.1833 8.15385 31.8462 10.8125 31.8462 14.1274V25.8726C31.8462 29.1833 29.1875 31.8462 25.8726 31.8462H14.1274C10.8167 31.8462 8.15385 29.1875 8.15385 25.8726V14.1274C8.15385 10.8167 10.8125 8.15385 14.1274 8.15385ZM28.0769 10.3077C27.1851 10.3077 26.4615 11.0313 26.4615 11.9231C26.4615 12.8149 27.1851 13.5385 28.0769 13.5385C28.9688 13.5385 29.6923 12.8149 29.6923 11.9231C29.6923 11.0313 28.9688 10.3077 28.0769 10.3077ZM20 12.4615C15.848 12.4615 12.4615 15.848 12.4615 20C12.4615 24.152 15.848 27.5385 20 27.5385C24.152 27.5385 27.5385 24.152 27.5385 20C27.5385 15.848 24.152 12.4615 20 12.4615ZM20 14.6154C22.9868 14.6154 25.3846 17.0132 25.3846 20C25.3846 22.9868 22.9868 25.3846 20 25.3846C17.0132 25.3846 14.6154 22.9868 14.6154 20C14.6154 17.0132 17.0132 14.6154 20 14.6154Z"
        fill={fill}
      />
    </svg>
  );
};

export default InstagramIcon;
